import React, { useState } from 'react';
import "./summary.css";
import { Row, Col, Container, Button } from "reactstrap";
import Lightbox from "../lightbox/lightbox";
import OverlayEffect from "../overlayEffect/overlayEffect";

import imgEixos from "../../assets/images/bncc-eixos.png";
import imgBnc from "../../assets/images/educacaobasica.jpg";


function Summary() {

    const [isLightboxVisible, setIsLightboxVisible] = useState(false);

    return (
        <div>
            <Row className="mt-5 pb-5 summaryBg text-right">
                <Container>
                    <Row>
                        <Col xs="12" md="8" lg="8"></Col>
                        <Col xs="12" md="4" lg="4" className="text-right">
                            <h3 className="mt-5 text-warning font36">Como Utilizar o PORTAL NSC ESCOLA</h3>
                            <div className="text-light font20">
                                O Portal NSC Escola foi concebido para que Professores possam buscar
                                e utilizar conteúdos do NSC Total como ponto de partida para
                                contextualizar planos de aulas.
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs="12" md="4" lg="4"></Col>
                        <Col xs="12" md="8" lg="8" className="text-right">
                            <h3 className="mt-2 text-light font36">Busca por Eixos da BNCC</h3>
                            <div className="text-light font20">
                                O portal apresenta duas funcionalidades: buscar qualquer termo
                                desejado pelos professores e a opção de pesquisa por Eixo do
                                BNCC. A ferramenta apresenta os 5 eixos do BNCC que são
                                Linguagens e suas Tecnologias (LIT), Matemática e suas Tecnologias (MTT),
                                Ciências da Natureza e suas Tecnologias (CNT), Ciências Humanas e Sociais Aplicadas (CHSA),
                                Formação Técnica e Profissional (FTP).
                            </div>
                            <Button size="lg" outline color="light" className="borderRadius10 mt-3">SAIBA MAIS</Button>
                        </Col>                        
                    </Row>
                </Container>                
            </Row>
            <Row className="pb-5 bg-light">
                <Container>
                    <Row className="m-auto">
                        <Col xs="12" md="6" lg="6" xl="6">
                            <h2 className="mt-5 font36 letter-space-8p">A BNCC</h2>
                            <p className="text-justify text-dark font20">
                                A presente versão da Base Nacional Comum Curricular (BNCC) completa o
                                trabalho de quatro anos ao longo dos quais o Ministério da Educação (MEC)
                                coordenou o processo de discussão e elaboração da norma que deve orientar
                                os rumos da Educação Básica no País.
                            </p>
                            <p className="text-justify text-dark font20">
                                A BNCC é um documento plural e contemporâneo, resultado de um trabalho coletivo
                                inspirado nas mais avançadas experiências do mundo. A partir dela, as redes de
                                ensino e instituições escolares públicas e particulares passarão a ter uma referência
                                nacional comum e obrigatória para a elaboração dos seus currículos e propostas pedagógicas,
                                promovendo a elevação da qualidade do ensino com equidade e preservando a autonomia dos entes
                                federados e as particularidades regionais e locais.
                            </p>
                            <p>
                                <Button color="primary" className="borderRadius10" href="http://basenacionalcomum.mec.gov.br/abase/" target="_blank" >
                                    <b>VISITE O SITE OFICIAL DO BNCC</b>
                                </Button>
                            </p>
                        </Col>
                        <Col xs="12" md="6" lg="6" xl="6" className="pt-5">
                            <div onClick={() => setIsLightboxVisible(true)}>
                                <OverlayEffect>
                                    <img src={imgEixos} alt="Imagem Eixos" className="image" style={{ width: "100%" }} />
                                </OverlayEffect>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </Row>
            {isLightboxVisible ? (
                <Lightbox onClose={() => setIsLightboxVisible(false)}>
                    <img src={imgBnc} alt={"imagem do ensino básico BNCC"} />
                </Lightbox>
            ) : null}
        </div>
    );
}

export default Summary;
